import { useSelectLocked } from 'layoutRenderer/store/selectors';
import { usePortfolioPlConfigSlice } from 'widgets/portfolioPl/store/config/configSlice';

export function usePortfolioPlLegendStatus(): {
    hidePerformanceLegends: boolean;
    hideLeavesLegends: boolean;
    showLeavesNetLegend: boolean;
    showLeavesBuysLegend: boolean;
    showLeavesSellsLegend: boolean;
} {
    const isLocked = useSelectLocked();

    const { config } = usePortfolioPlConfigSlice();
    const {
        aggregationType,
        index,
        hideRealizedPnlLegend,
        hideUnrealizedPnlLegend,
        hideTotalPnlLegend,
        hideIndexPnlLegend,
        leavesHideNetLegend,
        leavesHideBuysLegend,
        leavesHideSellsLegend,
    } = config;

    let showLeavesNetLegend = aggregationType === 'combined';
    let showLeavesBuysLegend = aggregationType !== 'sells';
    let showLeavesSellsLegend = aggregationType !== 'buys';

    let hideLeavesLegends = false;
    let hidePerformanceLegends = false;

    if (isLocked) {
        // When the layout is locked we hide legends hidden in config...

        hidePerformanceLegends =
            hideRealizedPnlLegend &&
            hideUnrealizedPnlLegend &&
            hideTotalPnlLegend &&
            (!index || hideIndexPnlLegend);

        showLeavesNetLegend = showLeavesNetLegend && !leavesHideNetLegend;
        showLeavesBuysLegend = showLeavesBuysLegend && !leavesHideBuysLegend;
        showLeavesSellsLegend = showLeavesSellsLegend && !leavesHideSellsLegend;

        const showLeavesLegends =
            showLeavesNetLegend ||
            showLeavesBuysLegend ||
            showLeavesSellsLegend;

        hideLeavesLegends = !showLeavesLegends;
    }

    return {
        hidePerformanceLegends,
        hideLeavesLegends,
        showLeavesNetLegend,
        showLeavesBuysLegend,
        showLeavesSellsLegend,
    };
}
